import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-up",
  "use": "icon-chevron-up-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chevron-up\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.11789 2.82818L7.91789 5.62818L9.33789 4.21818L5.84789 0.718184C5.45789 0.328185 4.82789 0.328185 4.43789 0.718184L0.937891 4.21818L2.35789 5.63818L5.15789 2.84818L5.11789 2.82818Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol